// Dependencies
import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";

// Material UI Components
import Chip from "@mui/material/Chip";

// Helpers
import { listingPropTypes } from "custom-prop-types/listing-props";

// Styles
import { useStyles } from "./VehicleSaleTypeChip.styles";

const VehicleSaleTypeChip = ({ listing, isDesktop }) => {
  const classes = useStyles({ isDesktop });

  const getChipType = () => {
    if (listing.seller.sellerType === "dealership") {
      return {
        label: isDesktop ? "Dealership" : "",
        color: "primary",
        className: classes.chip,
      };
    }
    return {
      label: isDesktop ? "Private Sale" : "",
      className: clsx(classes.chip, classes.privateChip),
    };
  };

  return <Chip size="small" variant="outlined" {...getChipType()} />;
};

VehicleSaleTypeChip.propTypes = {
  listing: listingPropTypes,
  isDesktop: PropTypes.bool.isRequired,
};

VehicleSaleTypeChip.defaultProps = {
  listing: {},
};

export default VehicleSaleTypeChip;
